var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',[_c('section',{class:!(_vm.user && !_vm.user.isAnonymous) ? '' : 'hidden',attrs:{"id":"firebaseui-auth-container"}}),_vm._v(" "),(_vm.user && !_vm.user.isAnonymous)?_c('div',[_vm._v("Logged in as "+_vm._s(_vm.user.displayName)+" "),_c('a',{on:{"click":_vm.signOut}},[_vm._v("Sign out")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-290a47ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 